export const DIFICULTIES = [
  'Beginner',
  'Intermediate',
  'Advanced',
] as const;

export type DifficultyT = typeof DIFICULTIES[number];
